import React, { Component } from 'react';
import { getAssetsUrl } from '../modules/config';

export default class Home extends Component {
  onSwatchClick = name => () => {
    const { setAppState, product } = this.props;
    if (!product[name].products) return;
    if (product[name].products.configLink) {
      window.location.href = product[name].products.configLink;
      return;
    }
    setAppState({ path: name });

    let path = '';
    if (this.props.match.params.type) {
      path = `/${this.props.match.params.type}/${name}`;
    } else {
      path = `/${name}`;
    }

    this.props.history.push(`/configure${path}`);
    // window.location.href = `${window.location.href}/${name}`;
    // window.location.origin + `/configure/${this.props.type}/${name}`;
  };
  render() {
    const { product, name } = this.props;
    return (
      <div className="app-body home">
        <h2 style={{ textAlign: 'center', marginTop: '1em' }}>CHOOSE {name}</h2>
        <div className="swatches-body">
          {Object.keys(product).map(productName => (
            <div
              className={`swatch-body${
                product[productName].products ? '' : ' disabled'
              }`}
              key={productName}
              onClick={this.onSwatchClick(productName)}
            >
              <img
                className="swatch-img"
                src={
                  product[productName].thumbnailUrl ||
                  getAssetsUrl(['image', 'imageNotFound.png'])
                }
                alt={productName}
              />
              <div className="swatch-label">{productName}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js